<script>
export default {
  name: 'MaximizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7934 1.33301H5.20671C2.78004 1.33301 1.33337 2.77967 1.33337 5.20634V10.7863C1.33337 13.2197 2.78004 14.6663 5.20671 14.6663H10.7867C13.2134 14.6663 14.66 13.2197 14.66 10.793V5.20634C14.6667 2.77967 13.22 1.33301 10.7934 1.33301ZM7.68671 9.01967L5.20671 11.4997H6.66671C6.94004 11.4997 7.16671 11.7263 7.16671 11.9997C7.16671 12.273 6.94004 12.4997 6.66671 12.4997H4.00004C3.93337 12.4997 3.86671 12.4863 3.80671 12.4597C3.68671 12.4063 3.58671 12.313 3.53337 12.1863C3.51337 12.1263 3.50004 12.0663 3.50004 11.9997V9.33301C3.50004 9.05967 3.72671 8.83301 4.00004 8.83301C4.27337 8.83301 4.50004 9.05967 4.50004 9.33301V10.793L6.98004 8.31301C7.17337 8.11967 7.49337 8.11967 7.68671 8.31301C7.88004 8.50634 7.88004 8.82634 7.68671 9.01967ZM12.5 6.66634C12.5 6.93967 12.2734 7.16634 12 7.16634C11.7267 7.16634 11.5 6.93967 11.5 6.66634V5.20634L9.02004 7.68634C8.92004 7.78634 8.79337 7.83301 8.66671 7.83301C8.54004 7.83301 8.41337 7.78634 8.31337 7.68634C8.12004 7.49301 8.12004 7.17301 8.31337 6.97967L10.7934 4.49967H9.33337C9.06004 4.49967 8.83337 4.27301 8.83337 3.99967C8.83337 3.72634 9.06004 3.49967 9.33337 3.49967H12C12.0667 3.49967 12.1267 3.51301 12.1934 3.53967C12.3134 3.59301 12.4134 3.68634 12.4667 3.81301C12.4867 3.87301 12.5 3.93301 12.5 3.99967V6.66634Z"
      :fill="color"
    />
  </svg>
</template>
